import { render, staticRenderFns } from "./PaymentAdded.vue?vue&type=template&id=3c22fff6"
import script from "./PaymentAdded.vue?vue&type=script&lang=js"
export * from "./PaymentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports